import Vue from 'vue';
import Component from 'vue-class-component';

import HeartIt from 'common/components/HeartIt';
import Rating from 'common/components/Rating';
import OneGuestIcon from 'common/icons/1Parcitipante.svg';
import TwoGuestsIcon from 'common/icons/2Participantes.svg';
import PlusGuestsIcon from 'common/icons/MasParticipantes.svg';
import getParticipantsIcon from 'common/services/utils/getParticipantsIcon';
import ActivityCardHours from 'ecommerce/components/ActivityCardHours/ActivityCardHours.vue';
import { useBoxCatalogViewStore } from 'ecommerce/stores/boxCatalogView.store.js';

@Component({
  components: {
    HeartIt,
    DiscountLabel: () => import('common/components/DiscountLabel'),
    Rating,
    ActivityCardHours,
  },
  props: {
    product: {
      type: Object,
      required: true,
      description: 'This could be a box, activity or package object',
    },
    availableHours: {
      type: Array,
      required: false,
      default: () => [],
    },
    coverPaddingBottom: {
      type: String,
      required: true,
      description:
        'Percentage that controls the height of the cover. E.g.: "62" ',
    },
    productTitle: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    discount: {
      type: [String, Number],
      description: 'Required for the discount label to be displayed',
    },
    campaignColor: {
      type: String,
      required: false,
    },
    showHeart: {
      type: Boolean,
      default: true,
    },
    boxColour: {
      type: String,
      required: false,
    },
    bigBlock: {
      type: Boolean,
      default: false,
      description:
        'Change styles of the Block. True if 3 blocks will be displayed in a row',
    },
  },
  setup() {
    const catalogViewStore = useBoxCatalogViewStore();

    return {
      catalogViewStore,
    };
  },
})
export default class ProductBlockComponent extends Vue {
  OneGuestIcon = OneGuestIcon;
  TwoGuestsIcon = TwoGuestsIcon;
  PlusGuestsIcon = PlusGuestsIcon;
  isRaffle = false;
  amount = null;
  isActivityType = null;

  mounted() {
    this.isRaffle = false;
    this.amount = 0;
    this.isActivityType = this.product.__typename === 'ActivityType';
    /* sorteo, cupos limitados, hasta agotar stock, agotado */
  }

  beforeCreate() {
    document.addEventListener('lazybeforeunveil', e => {
      const bg = e.target.getAttribute('data-bg');
      if (bg) {
        e.target.style.backgroundImage = `url(${bg})`;
      }
    });
  }

  get participantsIcon() {
    const amount = getParticipantsIcon(this.product.participants);

    if (amount === '1Parcitipante') {
      return this.OneGuestIcon;
    }
    if (amount === '2Participantes') {
      return this.TwoGuestsIcon;
    }
    if (amount === 'MasParticipantes') {
      return this.PlusGuestsIcon;
    }
    return this.OneGuestIcon;
  }

  get hasPriceSlot() {
    return !!this.$slots.price;
  }

  get isActivityClosed() {
    return (
      ['PartnerActivityType', 'ActivityType'].includes(
        this.product.__typename,
      ) && this.product.activity_type === 'closed'
    );
  }

  get showAvailableHoursSlider() {
    return (
      this.availableHours.length > 0 &&
      this.catalogViewStore.flags.alreadySearchedByDate
    );
  }

  get image() {
    switch (this.bigBlock) {
      case true:
        if (this.$screen.width < 768) {
          return `https://media.bigbox.com.ar/1/fill/0/300/ce/1/${btoa(
            this.product.product_image_url,
          )}`;
        }
        return `https://media.bigbox.com.ar/1/fill/600/0/ce/1/${btoa(
          this.product.product_image_url,
        )}`;
      default:
        if (this.$screen.width < 768) {
          return `https://media.bigbox.com.ar/1/fit/180/0/ce/1/${btoa(
            this.product.product_image_url,
          )}`;
        }
        return `https://media.bigbox.com.ar/1/fit/283/0/ce/1/${btoa(
          this.product.product_image_url,
        )}`;
    }
  }
}
